export default "{\n    \"emailLabel\": \"Correo electrónico\",\n    \"pushLabel\": \"Aplicación\",\n    \"smsLabel\": \"Texto\"\n}\n"